import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { defer, from, Observable } from "rxjs";
import {
  filter,
  map,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from "rxjs/operators";
import { Plant } from "src/model/class/general classes/plant";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "src/service/logger.service";
import { ThemeService } from "src/service/theme.service";
import { UtilityService } from "src/service/utility.service";
import { isHydrated } from "src/state/hydrate";

@Injectable({
  providedIn: "root",
})
export class SplashGuardGuard  {
  private _logContext: string = "Splash-guard.ts";

  constructor(
    private _utilityService: UtilityService,
    private _store: Store,
    private _loggerService: LoggerService,
    private _themeService: ThemeService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkIsStoreReady().pipe(
      tap((appConfig) => this._themeService.setApplicationTheme()),
      map((appConfig) => {
        return true;
      })
    );
  }

  /**
   *   This method check if the NgRx store has already been initialised (IE. hydrated) from the local storage.
   * It does so observing the value of the "hydrated" feature.
   * @returns An observable. This Observable shall not emit until the "hydrated" feature changes its value to TRUE.
   */
  private checkIsStoreReady(): Observable<boolean> {
    return this._store.select(isHydrated).pipe(
      tap((isHydrated: boolean) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          " checkIsStoreReady() ",
          "isHydrated: " + isHydrated
        );
      }),
      filter((isHydrated: boolean) => isHydrated),
      tap((isHydrated: boolean) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          " checkIsStoreReady() ",
          "GO AHEAD!"
        );
      }),
      take(1)
    );
  }
}
